module.exports = __webpack_public_path__ + "img/identify06.b1ec50aa.png";